/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from "../ApiClient";
import CreateCustomerRequest from '../model/CreateCustomerRequest';
import CreateCustomerResponse from '../model/CreateCustomerResponse';
import CreateCustomerSupplyAppointmentsRequest from '../model/CreateCustomerSupplyAppointmentsRequest';
import CreateCustomerSupplyAppointmentsResponse from '../model/CreateCustomerSupplyAppointmentsResponse';
import DeleteCustomerResponse from '../model/DeleteCustomerResponse';
import DeleteCustomerSupplyAppointmentsResponse from '../model/DeleteCustomerSupplyAppointmentsResponse';
import ErrorResponse from '../model/ErrorResponse';
import GetCustomerResponse from '../model/GetCustomerResponse';
import GetUploadStatusResponse from '../model/GetUploadStatusResponse';
import SearchCustomersResponse from '../model/SearchCustomersResponse';
import UpdateCustomerRequest from '../model/UpdateCustomerRequest';
import UpdateCustomerResponse from '../model/UpdateCustomerResponse';
import UpdateCustomerSupplyAppointmentsRequest from '../model/UpdateCustomerSupplyAppointmentsRequest';
import UpdateCustomerSupplyAppointmentsResponse from '../model/UpdateCustomerSupplyAppointmentsResponse';
import UploadCustomerCsvResponse from '../model/UploadCustomerCsvResponse';

/**
* Customers service.
* @module api/CustomersApi
* @version 2020-12-7
*/
export default class CustomersApi {

    /**
    * Constructs a new CustomersApi. 
    * @alias module:api/CustomersApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * 顧客を登録する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CreateCustomerResponse} and HTTP response
     */
    createCustomerWithHttpInfo(body, opts) {
      opts = opts || {};
      let postBody = body;

      let pathParams = {
      };
      let queryParams = {
        'insert': opts['insert'],
        'upsert': opts['upsert']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CreateCustomerResponse;

      return this.apiClient.callApi(
        '/customers', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 顧客を登録する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CreateCustomerResponse}
     */
    createCustomer(body, opts) {
      return this.createCustomerWithHttpInfo(body, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 配送日を指定する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CreateCustomerSupplyAppointmentsResponse} and HTTP response
     */
    createCustomerSupplyAppointmentsWithHttpInfo(body, customerId) {
      let postBody = body;

      let pathParams = {
        'customerId': customerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CreateCustomerSupplyAppointmentsResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}/supply-appointments', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 配送日を指定する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CreateCustomerSupplyAppointmentsResponse}
     */
    createCustomerSupplyAppointments(body, customerId) {
      return this.createCustomerSupplyAppointmentsWithHttpInfo(body, customerId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    customerCsvPreflightWithHttpInfo(groupId) {
      let postBody = null;

      let pathParams = {
        'groupId': groupId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/groups/{groupId}/customer-csv', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    customerCsvPreflight(groupId) {
      return this.customerCsvPreflightWithHttpInfo(groupId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    customerCsvUploadStatusPreflightWithHttpInfo(groupId, uploadStatusId) {
      let postBody = null;

      let pathParams = {
        'groupId': groupId,
        'uploadStatusId': uploadStatusId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/groups/{groupId}/customer-csv/{uploadStatusId}/status', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    customerCsvUploadStatusPreflight(groupId, uploadStatusId) {
      return this.customerCsvUploadStatusPreflightWithHttpInfo(groupId, uploadStatusId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    customersIdPreflightWithHttpInfo(customerId) {
      let postBody = null;

      let pathParams = {
        'customerId': customerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/customers/{customerId}', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    customersIdPreflight(customerId) {
      return this.customersIdPreflightWithHttpInfo(customerId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    customersIdSupplyAppointmentsPreflightWithHttpInfo(customerId) {
      let postBody = null;

      let pathParams = {
        'customerId': customerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/customers/{customerId}/supply-appointments', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    customersIdSupplyAppointmentsPreflight(customerId) {
      return this.customersIdSupplyAppointmentsPreflightWithHttpInfo(customerId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    customersIdSupplyAppointmentsPreflight_0WithHttpInfo(customerId) {
      let postBody = null;

      let pathParams = {
        'customerId': customerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/customers/{customerId}/supply-appointments/{timestamp}', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    customersIdSupplyAppointmentsPreflight_0(customerId) {
      return this.customersIdSupplyAppointmentsPreflight_0WithHttpInfo(customerId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    customersPreflightWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/customers', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    customersPreflight() {
      return this.customersPreflightWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 顧客を削除する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DeleteCustomerResponse} and HTTP response
     */
    deleteCustomerWithHttpInfo(customerId, opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
        'customerId': customerId
      };
      let queryParams = {
        'dryrun': opts['dryrun']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = DeleteCustomerResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 顧客を削除する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DeleteCustomerResponse}
     */
    deleteCustomer(customerId, opts) {
      return this.deleteCustomerWithHttpInfo(customerId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 配送指定を消去する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DeleteCustomerSupplyAppointmentsResponse} and HTTP response
     */
    deleteCustomerSupplyAppointmentsWithHttpInfo(customerId, timestamp) {
      let postBody = null;

      let pathParams = {
        'customerId': customerId,
        'timestamp': timestamp
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = DeleteCustomerSupplyAppointmentsResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}/supply-appointments/{timestamp}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 配送指定を消去する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DeleteCustomerSupplyAppointmentsResponse}
     */
    deleteCustomerSupplyAppointments(customerId, timestamp) {
      return this.deleteCustomerSupplyAppointmentsWithHttpInfo(customerId, timestamp)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 顧客を1件取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetCustomerResponse} and HTTP response
     */
    getCustomerWithHttpInfo(customerId) {
      let postBody = null;

      let pathParams = {
        'customerId': customerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetCustomerResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 顧客を1件取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetCustomerResponse}
     */
    getCustomer(customerId) {
      return this.getCustomerWithHttpInfo(customerId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 顧客CSV登録の状況を取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetUploadStatusResponse} and HTTP response
     */
    getCustomerCsvUploadStatusWithHttpInfo(groupId, uploadStatusId) {
      let postBody = null;

      let pathParams = {
        'groupId': groupId,
        'uploadStatusId': uploadStatusId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetUploadStatusResponse;

      return this.apiClient.callApi(
        '/groups/{groupId}/customer-csv/{uploadStatusId}/status', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 顧客CSV登録の状況を取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetUploadStatusResponse}
     */
    getCustomerCsvUploadStatus(groupId, uploadStatusId) {
      return this.getCustomerCsvUploadStatusWithHttpInfo(groupId, uploadStatusId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 顧客を検索し取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SearchCustomersResponse} and HTTP response
     */
    searchCustomersWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'customerCode': opts['customerCode'],
        'groupId': opts['groupId'],
        'serialNo': opts['serialNo'],
        'name': opts['name'],
        'tel': opts['tel'],
        '_with': opts['_with']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = SearchCustomersResponse;

      return this.apiClient.callApi(
        '/customers', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 顧客を検索し取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SearchCustomersResponse}
     */
    searchCustomers(opts) {
      return this.searchCustomersWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 顧客を更新する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UpdateCustomerResponse} and HTTP response
     */
    updateCustomerWithHttpInfo(body, customerId) {
      let postBody = body;

      let pathParams = {
        'customerId': customerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = UpdateCustomerResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 顧客を更新する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UpdateCustomerResponse}
     */
    updateCustomer(body, customerId) {
      return this.updateCustomerWithHttpInfo(body, customerId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 配送指定を更新する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UpdateCustomerSupplyAppointmentsResponse} and HTTP response
     */
    updateCustomerSupplyAppointmentsWithHttpInfo(body, customerId, timestamp) {
      let postBody = body;

      let pathParams = {
        'customerId': customerId,
        'timestamp': timestamp
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = UpdateCustomerSupplyAppointmentsResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}/supply-appointments/{timestamp}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 配送指定を更新する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UpdateCustomerSupplyAppointmentsResponse}
     */
    updateCustomerSupplyAppointments(body, customerId, timestamp) {
      return this.updateCustomerSupplyAppointmentsWithHttpInfo(body, customerId, timestamp)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 顧客情報をCSVで一括登録する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UploadCustomerCsvResponse} and HTTP response
     */
    uploadCustomerCsvWithHttpInfo(body, groupId) {
      let postBody = body;

      let pathParams = {
        'groupId': groupId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['text/csv'];
      let accepts = ['application/json'];
      let returnType = UploadCustomerCsvResponse;

      return this.apiClient.callApi(
        '/groups/{groupId}/customer-csv', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 顧客情報をCSVで一括登録する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UploadCustomerCsvResponse}
     */
    uploadCustomerCsv(body, groupId) {
      return this.uploadCustomerCsvWithHttpInfo(body, groupId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }

}
